import React from 'react';

export function SignUpNotice() {
  return (
    <div className='text-base leading-relaxed v2-text-neutral-900'>
      By signing up you are agreeing to the Bonjoro &nbsp;
      <a
        target='_blank'
        href='https://www.bonjoro.com/terms-and-conditions'
        className='v2-text-neutral-500 hover:v2-text-neutral-500 underline hover:underline'
        rel='noreferrer'
      >
        Terms of Service
      </a>
      &nbsp; and &nbsp;
      <a
        target='_blank'
        href='https://www.bonjoro.com/privacy-policy'
        className='v2-text-neutral-500 hover:v2-text-neutral-500 underline hover:underline'
        rel='noreferrer'
      >
        Privacy Policy
      </a>
    </div>
  );
}
